import { InitPage } from "../index";
import { showIntegrationToast } from "./integration_toast";

declare var $: any;

class IntegrationSubview {
    private modal: any;
    private opener: any = null;
    private loading = false;
    private request: any = null;

    init() {
        this.modal = $("#editIntegration");
        $(document).on("change", '#syncCatalogView input[name="truncate_catalog"]', () => this.onTruncateChange());
        if (!this.modal.length) return;

        this.modal.on("click", ".int-subview-open", (e: any) => this.load($(e.currentTarget)));
        this.modal.on("click", ".int-subview-back", (e: any) => {
            e.preventDefault();
            this.back();
        });
        this.modal.on("keydown", (e: any) => {
            if (e.key === "Escape" && this.isOpen()) {
                e.preventDefault();
                this.back();
            }
        });
        this.modal.on("hide.bs.modal", (e: any) => {
            if (e.target === this.modal[0] && this.isLocked()) e.preventDefault();
        });
        this.modal.on("hidden.bs.modal", (e: any) => {
            if (e.target !== this.modal[0]) return;
            if (this.request) this.request.abort();
            this.close();
        });
        $(document).on("integrations:subview-loaded", (_e: any, html: string) => this.show(html));
        $(document).on("integrations:subview-back", () => this.back());
    }

    content() {
        return this.modal.find(".modal-content");
    }

    isOpen() {
        return this.content().hasClass("int-sub-open");
    }

    isLocked() {
        return this.modal.hasClass("int-subview-locked");
    }

    load(button: any) {
        if (this.loading || button.prop("disabled") || button.hasClass("disabled")) return;
        this.loading = true;
        this.opener = button;
        this.modal.find(".int-loading-text").text(String(button.data("loading-text") || ""));
        this.content().addClass("int-busy").attr("aria-busy", "true");
        this.request = $.ajax({ url: button.data("url"), dataType: "script" })
            .fail((xhr: any) => {
                if (xhr.statusText !== "abort") showIntegrationToast("Couldn't load this screen. Please try again.", "error");
            })
            .always(() => {
                this.loading = false;
                this.request = null;
                this.content().removeClass("int-busy").removeAttr("aria-busy");
            });
    }

    show(html: string) {
        if (!this.modal.hasClass("in")) return;
        const subview = $("#int-subview").html(html);
        subview.find(".int-unsaved-note").toggle($("#int-status").hasClass("dirty"));
        this.content().addClass("int-sub-open");
        this.animate(subview, "int-slide-in");
        subview.find("button.int-subview-back").first().trigger("focus");
        $(document).trigger("integrations:subview-shown", [subview.children().first().attr("id")]);
    }

    back() {
        if (!this.isOpen() || this.isLocked()) return;
        this.close();
        this.animate(this.modal.find(".dlg-body"), "int-slide-back");
        if (this.opener) this.opener.trigger("focus");
    }

    close() {
        if (!this.isOpen()) return;
        $(document).trigger("integrations:subview-closed");
        this.modal.removeClass("int-subview-locked");
        this.content().removeClass("int-sub-open");
        $("#int-subview").empty();
    }

    animate(element: any, className: string) {
        element.removeClass("int-slide-in int-slide-back");
        void element[0]?.offsetWidth;
        element.addClass(className);
    }

    onTruncateChange() {
        const view = $("#syncCatalogView");
        const truncate = view.find('input[name="truncate_catalog"]:checked').val() === "true";
        view.find(".choice").each((_: number, el: HTMLElement) => {
            $(el).toggleClass("on", $(el).find("input").is(":checked"));
        });
        view.find(".truncate-warning").toggle(truncate);
        const submit = $("#sync-catalog-submit");
        submit.toggleClass("danger", truncate).val(submit.data(truncate ? "truncate-label" : "start-label"));
    }
}

export function LoadPage() {
    InitPage("integrations", () => {
        new IntegrationSubview().init();
    });
}
